import { withAuthUser } from 'next-firebase-auth'
import { ContactUs } from 'views/contact-us'

export default withAuthUser()(ContactUs)
